"use client";

import * as Headless from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/16/solid";
import React, { useState } from "react";
import skogforskLogo from "../assets/Skogforsk Logotyp_Original_Urskog RGB 750 px.png";
import { Button } from "./button";
import { NavbarItem } from "./navbar";
import { SidebarLabel } from "./sidebar";

// function OpenMenuIcon() {
//   return (
//     <svg data-slot="icon" viewBox="0 0 20 20" aria-hidden="true">
//       <path d="M2 6.75C2 6.33579 2.33579 6 2.75 6H17.25C17.6642 6 18 6.33579 18 6.75C18 7.16421 17.6642 7.5 17.25 7.5H2.75C2.33579 7.5 2 7.16421 2 6.75ZM2 13.25C2 12.8358 2.33579 12.5 2.75 12.5H17.25C17.6642 12.5 18 12.8358 18 13.25C18 13.6642 17.6642 14 17.25 14H2.75C2.33579 14 2 13.6642 2 13.25Z" />
//     </svg>
//   );
// }

// function CloseMenuIcon() {
//   return (
//     <svg data-slot="icon" viewBox="0 0 20 20" aria-hidden="true">
//       <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
//     </svg>
//   );
// }

function MobileSidebar({ open, close, children }: { open: boolean; close: () => void; children: React.ReactNode }) {
  return (
    <Headless.Dialog open={open} onClose={close} className="fixed inset-0 z-50">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

      {/* Sidebar Panel */}
      <Headless.Dialog.Panel
        transition
        className="fixed inset-y-0 left-0 w-64 bg-white lg:bg-zinc-100 dark:bg-zinc-900 dark:lg:bg-zinc-950 transition-transform data-[closed]:-translate-x-full data-[enter]:duration-300 data-[leave]:duration-200"
      >
        {/* Close Button */}
        <div className="flex items-center justify-between p-2 lg:hidden">
          <Button plain className="p-2 text-gray-600 hover:bg-gray-100 rounded transition" onClick={close} aria-label="Close sidebar">
            <XMarkIcon />
          </Button>
          <div className="flex items-center">
            <img src={skogforskLogo} alt="Logo" className="h-8 w-8" />
            <SidebarLabel className="text-sm ml-2">Skogforsklabbet</SidebarLabel>
          </div>
        </div>
        {children}
      </Headless.Dialog.Panel>
    </Headless.Dialog>
  );
}

export function SidebarLayout({
  navbar,
  sidebar,
  children,
}: React.PropsWithChildren<{
  navbar: React.ReactNode;
  sidebar: React.ReactNode;
}>) {
  const [showSidebar, setShowSidebar] = useState(false);

  return (
    <div className="relative isolate flex h-screen w-screen bg-white max-lg:flex-col lg:bg-zinc-100 dark:bg-zinc-900 dark:lg:bg-zinc-950">
      {/* Sidebar on desktop */}
      <div className="fixed inset-y-0 left-0 w-64 max-lg:hidden">{sidebar}</div>

      {/* Mobile Sidebar is always mounted; its visibility is controlled by "showSidebar" */}
      <MobileSidebar open={showSidebar} close={() => setShowSidebar(false)}>
        {sidebar}
      </MobileSidebar>

      {/* Navbar on mobile */}
      <header className="flex items-center px-4 lg:hidden">
        <div className="py-2.5">
          <NavbarItem
            onClick={() => {
              setShowSidebar(true);
            }}
            aria-label="Open navigation"
          >
            <Bars3Icon />
          </NavbarItem>
        </div>
        <div className="min-w-0 flex-1">{navbar}</div>
      </header>

      {/* Content */}
      <main className="flex-1 flex flex-col overflow-hidden lg:pl-64">
        {/* This div handles padding, background, and ensures it stretches. */}
        <div className="flex-1 flex flex-col p-6 lg:bg-white lg:p-10 lg:ring-1 lg:shadow-xs lg:ring-zinc-950/5 dark:lg:bg-zinc-950 dark:lg:ring-white/10 overflow-hidden">
          {/* This div sets max-width for content and ensures it fills the padded area vertically. */}
          <div className="w-full h-full max-w-full overflow-hidden">{children}</div>
        </div>
      </main>
    </div>
  );
}
